module.exports = __webpack_public_path__ + "img/spark_468_60.f245bb25.jpg";